import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const CountryDetailsForm = (props) => {
  const [countryName, setCountryName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [currencyCode, setCurrencyCode] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");

  const { sendRequest: postCountry } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      orgId: localStorage.getItem("orgId"),
      countryName,
      countryCode,
      currencyName,
      currencyCode,
      currencySymbol,
      status: 1,
    };

    if (props.update) {
      data["countryId"] = props.update.countryId;
    }

    postCountry(
      {
        url: "/api/countries/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (res) => {
        toast.success(`Country ${props.update ? "updated" : "added"} successfully`);
        props.addForm(false);
      },
      (error) => {
        toast.error("Something went wrong!");
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      setCountryName(props.update.countryName || "");
      setCountryCode(props.update.countryCode || "");
      setCurrencyName(props.update.currencyName || "");
      setCurrencyCode(props.update.currencyCode || "");
      setCurrencySymbol(props.update.currencySymbol || "");
    }
  }, [props.update]);

  return (
    <div className="content-wrapper">
      <section className="content">
        <form style={{ margin: "10px" }} onSubmit={submitHandler}>
          <div className="container-fluid">
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">Country</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="col-md-3">
                    <label>Country Name</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      value={countryName}
                      onChange={(e) => setCountryName(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Country Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Currency Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={currencyName}
                      onChange={(e) => setCurrencyName(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Currency Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={currencyCode}
                      onChange={(e) => setCurrencyCode(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-3">
                    <label>Currency Symbol</label>
                    <input
                      type="text"
                      className="form-control"
                      value={currencySymbol}
                      onChange={(e) => setCurrencySymbol(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row text-center mt-4">
                  <div className="col-md-12">
                    <button className="btn btn-primary" type="submit">
                      {props.update ? "Update" : "Add"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>
  );
};

export default CountryDetailsForm;
